module.exports = __webpack_public_path__ + "img/16.51725eb6.jpg";